import React from "react";

const CounterSection = () => {
  const counters = [
    {
      number: "200+",
      text: "Availabel Fleets",
    },
    {
      number: "100+",
      text: "Drivers",
    },
    {
      number: "2500+",
      text: "Happy People",
    },
    {
      number: "1100+",
      text: "Road Trips",
    },
  ];

  return (
    <section
      className="counter-one__container"
      data-id="d07aa4d"
      data-element_type="section"
    >
      <div className="elementor-container elementor-column-gap-default list-unstyled counters-one__box">
        <div
          className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f45917e"
          data-id="f45917e"
          data-element_type="column"
          data-settings='{"background_background":"classic"}'
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <section
              className="elementor-section elementor-inner-section elementor-element elementor-element-e271598 elementor-section-boxed elementor-section-height-default elementor-section-height-default row-top"
              data-id="e271598"
              data-element_type="section"
            >
              <div className="elementor-container elementor-column-gap-default">
                {counters.map((counter, index) => (
                  <div
                    key={index}
                    className={`elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-col-${index}`}
                    data-id={`col-${index}`}
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className={`elementor-element elementor-element-counter-${index} elementor-widget elementor-widget-gva-counter`}
                        data-id={`counter-${index}`}
                        data-element_type="widget"
                        data-widget_type="gva-counter.default"
                      >
                        <div className="elementor-widget-container">
                          <div className="gva-element-gva-counter gva-element">
                            <div className="widget milestone-block style-1">
                              <div className="box-content">
                                <div className="milestone-content">
                                  <div className="milestone-number-inner">
                                    <span className="milestone-number">
                                      {counter.number}
                                    </span>
                                  </div>
                                  <div className="milestone-text">
                                    {counter.text}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CounterSection;
